__turbopack_context__.v({
  "active": "_W-lrW_active",
  "disabled": "_W-lrW_disabled",
  "pagination": "_W-lrW_pagination",
  "pagination_wrapper": "_W-lrW_pagination_wrapper",
  "select": "_W-lrW_select",
});
